interface LogoProps {
  className?: string;
}

function ColoredLogo({ className }: LogoProps) {
  return (
    <div id="colored-logo">
      <svg
        className={className}
        viewBox="0 0 112 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.1544 36.051L64.5707 21.5174H90.5847L83.6986 33.5012H71.4567L59.7249 53.8992H52.5838L45.1922 41.0902L37.7912 53.8994H30.6501L0.0454102 0.864701H13.8175L34.2206 36.0512L38.2368 29.0373L21.9792 0.864502H36.0063L45.1876 16.8986L54.3687 0.864701H85.7385C100.276 0.864701 112.008 12.8485 112.008 27.382C112.008 41.9156 100.021 53.8994 85.4835 53.8994H67.8858L74.5168 41.9156H85.7385C93.8998 41.9156 100.276 35.5412 100.276 27.382C100.276 19.2229 93.6447 12.8485 85.7385 12.8485H61.5098L52.1472 29.0528L56.1544 36.051Z"
          fill="#6B97F6"
        />
      </svg>
    </div>
  );
}
export default ColoredLogo;
